module.exports = __webpack_public_path__ + "static/media/logo-credishop.ceaedd15.png";